import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import moment from "moment";

import { FormField } from "components/form/FormField/FormField";
import { Select } from "components/ui/Select/Select";

import style from "./LungsAdditionalInfoForm.module.css";

export const RadInvestigation = ({ form, name, button }) => {
  const shouldShowRestFields = form.watch(name) !== "not-done";
  const isResultAbnormal = form.watch(name + "Result") === "Abnormal";

  return (
    <div style={{ marginBottom: "8px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <FormField name={name}>
          <div className={style.winXpSelectWrapper} style={{ width: "150px" }}>
            <Select
              name={name}
              options={[
                { label: "Not done", value: "not-done" },
                { label: "Chest X-Ray", value: "chest-x-ray" },
                { label: "CT Scan", value: "ct-scan" },
              ]}
              value={form.watch(name)}
              onChange={(value) => {
                form.setValue(name, value);
              }}
              required
            />
          </div>
        </FormField>
        {button}
      </div>

      {shouldShowRestFields && (
        <>
          <div style={{ marginTop: "8px" }}>
            <FormField name={name + "Hospital"}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <label
                  className={style.addReferralFormLabel}
                  style={{
                    width: "80px",
                    fontWeight: "400",
                    fontSize: "13px",
                  }}
                >
                  Hospital
                </label>
                <input
                  className={style.winXpInputWrapper}
                  style={{ width: "200px" }}
                  {...form.register(name + "Hospital")}
                />
              </div>
            </FormField>
          </div>
          <div style={{ marginTop: "8px" }}>
            <FormField name={name + "Date"}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <label
                  className={style.addReferralFormLabel}
                  style={{
                    width: "80px",
                    fontWeight: "400",
                    fontSize: "13px",
                  }}
                >
                  Date
                </label>
                <div
                  className={`${style.addPregnancyDatePickerWrapper} ${style.winXpDatepickerWrapper}`}
                  style={{ width: "200px" }}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      format="DD-MM-YYYY"
                      name={name + "Date"}
                      value={
                        form.watch(name + "Date")
                          ? dayjs(form.watch(name + "Date"), "DD-MM-YYYY")
                          : null
                      }
                      sx={{
                        width: "100%",
                        height: "36px",
                      }}
                      onChange={(newValue) => {
                        form.setValue(
                          name + "Date",
                          newValue
                            ? moment(new Date(dayjs(newValue))).format(
                                "DD-MM-YYYY"
                              )
                            : null
                        );
                      }}
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </FormField>
          </div>
          <div style={{ marginTop: "8px" }}>
            <FormField name={name + "Result"}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <label
                  className={style.addReferralFormLabel}
                  style={{
                    width: "80px",
                    fontWeight: "400",
                    fontSize: "13px",
                  }}
                >
                  Result
                </label>
                <div
                  className={style.winXpSelectWrapper}
                  style={{ width: "200px" }}
                >
                  <Select
                    name={name}
                    options={[
                      { label: "Normal", value: "Normal" },
                      { label: "Abnormal", value: "Abnormal" },
                    ]}
                    value={form.watch(name + "Result")}
                    onChange={(value) => {
                      form.setValue(name + "Result", value);
                    }}
                    required
                  />
                </div>
              </div>
            </FormField>
          </div>
          {isResultAbnormal && (
            <div style={{ marginTop: "8px" }}>
              <FormField name={name + "Comment"}>
                <div
                  style={{ display: "flex", alignItems: "flex-start", gap: "16px" }}
                >
                  <label
                    className={style.addReferralFormLabel}
                    style={{
                      width: "80px",
                      fontWeight: "400",
                      fontSize: "13px",
                    }}
                  >
                    Comment
                    <span style={{ color: "#F72924" }}>*</span>
                  </label>
                  <textarea
                    className={style.winXpInputWrapper}
                    style={{ width: "200px" }}
                    {...form.register(name + "Comment")}
                  />
                </div>
              </FormField>
            </div>
          )}
        </>
      )}
    </div>
  );
};
